<template>
  <div>
    <el-form label-width="100px" :inline="inline" label-position="right" v-if="show">
      <!-- 如果是老数据 -->
      <el-form-item label="id" v-if="localValue.data.id">
        {{ localValue.data.id }}
      </el-form-item>
      <!-- 新字段 -->
      <el-form-item :label="item.name" v-for="(item, index) in localValue.config" :key="index" :required="item.required">
        <!-- {{ item.key }} -->

        <!-- {{ localValue.data[item.key] }} -->
        <XInput v-model="localValue.data[item.key]" :type="item.type" :options="item.options" :options_url="item.options_url" :remarks="item.remarks" :disabled="item.disabled" :inClass="item.class">
        </XInput>
      </el-form-item>
      <el-form-item label="" v-if="localValue.add_api">
        <el-button size="small" @click="close" v-if="!value.hide_close">取消</el-button>
        <el-button type="primary" size="small" @click="post_func(localValue.add_api)" :disabled="disabled">
          {{ localValue.data.id ? '修改' : '新增' }}
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import {http_post, http_get} from '@/api/api'
  import _ from 'lodash'

  export default {
    props: {
      value: {
        type: [Array, Object, String, Number, Boolean],
        default: () => null
      },
      inline: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        show: false,
        disabled: false,
        localValue: _.cloneDeep(this.value), // 深拷贝初始化
        localValue2: _.cloneDeep(this.value)
      }
    },
    watch: {
      localValue: {
        handler(newVal) {
          if (!this.isEqual(newVal, this.value)) {
            this.$emit('input', _.cloneDeep(newVal)) // 值变化时通知父级
          }
        },
        deep: true
      }
    },
    created() {
      this.fetchData()
    },
    methods: {
      async fetchData() {
        // 加载所有选项的数据
        let index = 1
        for (const item of this.localValue.config) {
          if (item.default) {
            this.$set(this.localValue.data, item.key, item.default)
          }
          // if (item.options_url) {

          // }
        }
        this.show = true
      },
      post_func(url) {
        this.disabled = true
        http_post(url, this.localValue.data).then(res => {
          this.disabled = false
          if (res.code == 200) {
            this.close(res.data)
          }
        })
      },
      close(data = null) {
        this.$emit('close', data)
      },
      isEqual(a, b) {
        // 智能值比对（处理所有数据类型）
        if (typeof a !== typeof b) return false
        if (typeof a === 'object' && a !== null && b !== null) {
          // 处理引用类型
          return _.isEqual(a, b) // 使用 lodash 深度比对
        }
        return a === b // 基本类型直接比对
      },
      handleInput(rawValue) {
        // 输入处理（类型转换）
        let processed = rawValue
        if (typeof this.value === 'number') {
          // 自动类型转换（根据初始值类型）
          processed = parseFloat(rawValue) || 0
        } else if (typeof this.value === 'boolean') {
          processed = Boolean(rawValue)
        }
        this.localValue = processed
      }
    }
  }
</script>

<style lang="scss" scoped>
  .el-form-item {
    margin-bottom: 10px;
  }
</style>
